module.exports = __webpack_public_path__ + "img/promotions.3eae0599.svg";